import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';
import { pastShiftTransitions, upcomingShiftTransitions } from '../../util/transaction';
const { UUID } = sdkTypes;
const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));
// ================ Action types ================ //

export const FETCH_WORKERS_DATA_REQUEST =
  'app/SuperAdminBusinessDetailsPage/FETCH_WORKERS_DATA_REQUEST';
export const FETCH_WORKERS_DATA_SUCCESS =
  'app/SuperAdminBusinessDetailsPage/FETCH_WORKERS_DATA_SUCCESS';
export const FETCH_WORKERS_DATA_ERROR =
  'app/SuperAdminBusinessDetailsPage/FETCH_WORKERS_DATA_ERROR';
export const FETCH_BLOCK_DATA_SUCCESS =
  'app/SuperAdminBusinessDetailsPage/FETCH_BLOCK_DATA_SUCCESS';
export const FETCH_BLOCK_REASON_SUCCESS =
  'app/SuperAdminBusinessDetailsPage/FETCH_BLOCK_REASON_SUCCESS';
export const FETCH_WORKING_STAFF_SUCCESS =
  'app/SuperAdminBusinessDetailsPage/FETCH_WORKING_STAFF_SUCCESS';
// ================ Reducer ================ //
const initialState = {
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentStaffData: [],
  blockerData: [],
  blockReason: [],
  workingStaffs: [],
};
export default function SuperAdminBusinessDetailsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_WORKERS_DATA_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchWorkersDataError: null,
        currentStaffData: [],
      };
    case FETCH_WORKERS_DATA_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentStaffData: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_BLOCK_DATA_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        blockerData: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_WORKERS_DATA_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchWorkersDataError: payload };
    case FETCH_BLOCK_REASON_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        blockReason: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_WORKING_STAFF_SUCCESS:
      const transactions = sortedTransactions(payload?.data?.data);
      // console.log(12452, transactions);
      return {
        ...state,
        workingStaffsRequest: false,
        workingStaffs: entityRefs(transactions),
        pagination: payload?.data?.meta,
        fetchInProgress: false,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchWorkersDataRequest = () => ({ type: FETCH_WORKERS_DATA_REQUEST });
const fetchWorkersDataSuccess = response => ({
  type: FETCH_WORKERS_DATA_SUCCESS,
  payload: response,
});
const fetchWorkersDataError = e => ({
  type: FETCH_WORKERS_DATA_ERROR,
  error: true,
  payload: e,
});
const fetchBlockerDataSuccess = response => ({
  type: FETCH_BLOCK_DATA_SUCCESS,
  payload: response,
});
const fetchBlockerReasonSuccess = response => ({
  type: FETCH_BLOCK_REASON_SUCCESS,
  payload: response,
});
export const fetchWorkingStaffSuccess = response => {
  return {
    type: FETCH_WORKING_STAFF_SUCCESS,
    payload: response,
  };
};
// ================ Thunks ================ //
export const fetchWorkersData = (workerId, businessId) => async (dispatch, getState, sdk) => {
  let apiCurrentUser;

  dispatch(fetchWorkersDataRequest());
  return axios
    .get(`${apiBaseUrl()}/api/user/admin/staffData?userId=${workerId}`, {
      withCredentials: true,
    })
    .then(response => {
      apiCurrentUser = response?.data;
    })
    .then(() => {
      if (!apiCurrentUser?.data?.attributes?.profile?.publicData?.isProvider) {
        return dispatch(fetchCurrentWorkerUserExtraDetails(apiCurrentUser?.data?.id?.uuid));
      }
      return null;
    })
    .then(res => {
      if (res !== null && typeof res === 'object') {
        Object.assign(apiCurrentUser?.data?.attributes?.profile?.publicData, res);
      }

      dispatch(fetchWorkersDataSuccess(apiCurrentUser));
    })
    .then(() => {
      return sdk.users.show({
        id: businessId,
        include: ['profileImage'],
        'fields.image': ['variants.default', 'variants.square-small', 'variants.square-small2x'],
      });
    })
    .then(res => {
      return dispatch(fetchBlockerDataSuccess(res.data));
    })
    .then(() => {
      return axios.get(
        `${apiBaseUrl()}/api/user/isWorkerBlockedbyAuthor/${businessId}/${workerId}`,
        {
          withCredentials: true,
        }
      );
    })
    .then(res => {
      return dispatch(fetchBlockerReasonSuccess(res.data));
    })
    .then(() => {
      return axios.post(`${apiBaseUrl()}/api/workerTransactionForBusiness`, {
        customerId: workerId,
        providerId: businessId,
      });
    })
    .then(res => {
      // console.log(444,res.data)
      const pastgigInfo = res?.data?.data?.data?.filter(m =>
        // pastShiftTransitions?.find(f => f === m?.attributes?.lastTransition)
        pastShiftTransitions?.includes(m?.attributes?.lastTransition)
      );
    

      const Resp = {
        status: 200,
        statusText: 'OK',
        data: {
          data:pastgigInfo,
          // data: res?.data?.data?.data,
          included: [],
          meta: {},
        },
      };
      // console.log(455, res, sp);

      dispatch(addMarketplaceEntities(res.data));
      dispatch(fetchWorkingStaffSuccess(Resp));
    })
    .catch(error => {
      dispatch(fetchWorkersDataError(error));
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const { businessId, workerId } = params;
  const queryPage = queryParams.page || 1;
  const slug = params.slug;

  dispatch(fetchWorkersData(workerId, businessId));
};
